/* eslint-disable no-console */
import axios from 'axios';
import { api } from '../config';
import store from '../store';
// eslint-disable-next-line no-unused-vars
import { logoutUserSuccess } from '../slices/auth/login/reducer';
import { quickDecrypt } from '../utils/crypto';

// Set baseURL global
axios.defaults.baseURL = api.API_URL;
axios.defaults.withCredentials = true;
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';

// Set Content-Type untuk POST
axios.defaults.headers.post['Content-Type'] = 'application/json';

// ✅ Ambil token dari Redux state (gunakan saat HYDRATED)

export const getTokenFromRedux = () => {
  try {
    const state = store.getState();
    const token = state?.Login?.user?.token || null;

    if (token && typeof token === 'string' && token.trim() !== '') {
      return token;
    }

    return null;
  } catch (error) {
    console.error('Gagal ambil token dari Redux:', error);
    return null;
  }
};

// ✅ Tambahkan Interceptor REQUEST
axios.interceptors.request.use(
  config => {
    const token = getTokenFromRedux();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  error => Promise.reject(error)
);

// ✅ Tambahkan Interceptor RESPONSE
axios.interceptors.response.use(
  response => (response?.data ? response.data : response),
  error => {
    const status = error?.response?.status;
    let message = 'Terjadi kesalahan.';

    switch (status) {
      case 500:
        message = 'Internal Server Error';
        break;
      case 401:
        message = 'Unauthorized - Token tidak valid atau habis';
        // AUTO_LOGOUT_DISABLED_START — disabled per issue #24 (multi-login support), 2026-07-17
        // sessionStorage.clear();
        // store.dispatch(logoutUserSuccess());
        // window.location.href = '/login';
        // return;
        // AUTO_LOGOUT_DISABLED_END
        break;
      case 404:
        message = 'Data tidak ditemukan';
        break;
      default:
        message = error?.response?.data?.message || error.message;
    }

    return Promise.reject(message);
  }
);

// ✅ Fungsi untuk set token manual (misal setelah login)
export const setAuthorization = token => {
  axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
};

// ✅ Class APIClient
class APIClient {
  get(url, params) {
    const query =
      params && Object.keys(params).length
        ? '?' +
          Object.entries(params)
            .map(([key, val]) => `${key}=${val}`)
            .join('&')
        : '';
    return axios.get(`${url}${query}`);
  }

  create(url, data) {
    return axios.post(url, data);
  }

  update(url, data) {
    return axios.patch(url, data);
  }

  put(url, data) {
    return axios.put(url, data);
  }

  delete(url, config = {}) {
    return axios.delete(url, { ...config });
  }
}

// const getLoggedinUser1 = () => {
//   try {
//     // First try to get from Redux store
//     const state = store.getState();
//     const reduxUser = state?.Login?.user;
//     if (reduxUser) {
//       return reduxUser;
//     }
//     const persistedState = sessionStorage.getItem('persist:root');
//     if (persistedState) {
//       const parsed = JSON.parse(persistedState);
//       const loginState = JSON.parse(parsed.Login || '{}');
//       console.log(loginState?.user);
//       return loginState?.user || null;
//     }

//     return null;
//   } catch (error) {
//     return null;
//   }
// };

const getLoggedinUser = () => {
  try {
    // First try to get from Redux store
    const state = store.getState();
    const reduxUser = state?.Login?.user;
    if (reduxUser) {
      return reduxUser;
    }
    const persistedState = sessionStorage.getItem('persist:root');
    if (persistedState) {
      const parsed = JSON.parse(persistedState);
      const loginState = quickDecrypt(parsed.Login || '{}');
      //console.log('token 1', loginState?.user);
      return loginState?.user || null;
    }

    return null;
  } catch (error) {
    return null;
  }
};

//  const loginState = quickDecrypt(parsed.Login || '{}');
//  console.log('data log', loginState?.user);

export { APIClient, getLoggedinUser };
